/*
 * Copyright 2026 Sony Corporation
 */
import { Card, CardActionArea, Stack, SvgIcon, Typography } from '@mui/material';

/** The first card of a grid: a plus that makes a new one. */
export const NewCard = ({
  label,
  onClick,
  minHeight = 260,
}: {
  label: string;
  onClick: () => void;
  minHeight?: number;
}) => (
  <Card variant="outlined" sx={{ borderStyle: 'dashed', borderWidth: 2, minHeight }}>
    <CardActionArea onClick={onClick} sx={{ height: '100%', minHeight }} aria-label={label}>
      <Stack spacing={1} sx={{ alignItems: 'center', color: 'primary.main' }}>
        <SvgIcon sx={{ fontSize: 56 }}>
          <path d="M11 5h2v6h6v2h-6v6h-2v-6H5v-2h6V5Z" />
        </SvgIcon>
        <Typography variant="subtitle1">{label}</Typography>
      </Stack>
    </CardActionArea>
  </Card>
);

/** The grid both the runtimes and the projects are laid out in. */
export const CARD_GRID = {
  display: 'grid',
  gap: 2,
  gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))',
} as const;
